import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TooltipTextarea = (props) => {
  const { t } = useTranslation();

  return (
    <div className="info-tooltip">
      <div className="m1" data-bem="TooltipTextarea">
        <p>{t('composite.tooltipTextarea.infoText', { count: props.numOfMessage })}</p>
        <div className="num-message-info">
          <span className="tooltip">
            <div className="tooltip-centered">{t('composite.tooltipTextarea.tooltipText')}</div>
          </span>
        </div>
      </div>
    </div>
  );
};

export default TooltipTextarea;
